type TypeParamsObj<T> = {
  arr: T[],
  keyname: keyof T,
  keyname2?: string,
  keyname3?: string,
  ascending?: boolean
}

export const sortBy = <T>({ arr, keyname, keyname2, keyname3, ascending = true }: TypeParamsObj<T>): T[] => {
  return arr.sort((a, b) => {
    let aValue = a[keyname]
    let bValue = b[keyname]

    if (typeof keyname2 === 'string') {
      if (typeof keyname3 === 'string') {
        aValue = a[keyname]?.[keyname2]?.[keyname3]
        bValue = b[keyname]?.[keyname2]?.[keyname3]
      } else {
        aValue = a[keyname]?.[keyname2]
        bValue = b[keyname]?.[keyname2]
      }
    }

    aValue = aValue ?? null
    bValue = bValue ?? null

    // If ascending order
    if (ascending) return aValue < bValue ? -1 : aValue > bValue ? 1 : 0
    // If descending order
    else return aValue > bValue ? -1 : aValue < bValue ? 1 : 0
  })
}
